/**
 * @function removeLeadingOne
 * @desc removeLeadingOne
 *
 * @param {String} number - the phone number.
 * @returns {String} number - number without leading 1.
 */
const removeLeadingOne = (number: string = ''): string => {
  if (number.length > 0) {
    if (number.charAt(0) === '1') return number.substring(1);

    return number;
  }

  return '';
};

export default removeLeadingOne;
